//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import $$ from 'jquery'
import Footer from '../footer/footer.vue'
import Header from '../header/header.vue'
import SocietyFloat from '../societyFloat/societyFloat.vue'
import Multiselect from "vue-multiselect";
import {requestByPost} from '@/util/request'
import { prewebUrl } from '@/config/project-config'
import Clipboard from "clipboard";
import {API} from '@/util/api'
import { Toast} from 'vant';
export default {
 name: 'societyArticleNews',
 data(){
  return {
    newsTypeList: [], //文章资讯分类集合
    newTypeIndex: -1,//选中分类
    societyId:  (this.$route.query.societyId != null && this.$route.query.societyId != '' ) ? this.$route.query.societyId : window.localStorage.getItem('societyId'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id,//平台机构id
    newstypeItemValue: '', // 分类value
    page: {
      pageNum: 0,
      pageSize: 10
    },
    zTotal: 0,// 总条数
    societyArticleNewsList: [],// 文章列表
    detailUrl: '',// 拼接的详情路径
    societyName:(this.$route.query.societyName != null && this.$route.query.societyName != '' ) ? this.$route.query.societyName : window.localStorage.getItem('societyName'),//0显示平台头部按钮  1显示机构头部按钮,  //机构id
    selType: (this.$route.query.selType != null && this.$route.query.selType != '' ) ? this.$route.query.selType : 1
  }
 },
 components:{
    Header,
    Footer,
	SocietyFloat,
    Multiselect
 },
mounted() {
   document.title = "文章资讯";
},
 computed:{
 },
 created(){
   this.$store.commit('home/setShowMenuType', 1);//机构菜单
   this.$store.commit('home/setMenuJgActive', 2);
   //获取机构id暂时注释 勿删
   this.fnType()
   
 },
  updated(){
    //每个16:6.8的图片加载完重新算高度
    $$(".autoHeight").each(function(){
      let widthNum = $$(this).width();
      $$(this).height(widthNum*6.8/16);
    });
    
  },
 methods:{
   fnType () {
     requestByPost(API.selAllSocietyArticleNewsType)
      .then((res) => {
        console.log(res)
        this.newsTypeList = res.data.objs
        if (this.selType == 2) {
			this.newTypeIndex = res.data.objs.length-1
        }
        this.newsListPage()
      })
   },
  newsListPage () {
    var params = {}
    if (this.societyId != null && this.societyId != undefined && this.societyId != '') {
      params.societyId = this.societyId
    }
    params.newstypeItemValue = this.newstypeItemValue
    params.page = this.page
    requestByPost(API.selSocietyArticleNewsPage,JSON.stringify(params))
      .then((res) => {
        console.log(res)
        this.societyArticleNewsList = res.data.otherList
        this.zTotal = res.data.obj.page.total
      })
  },
  onChange (current, pageSize) {
      this.page.pageSize = pageSize
      this.page.pageNum = current-1
      this.newsListPage()
  },
  fnChangeNewsType (index,itemValue) {
    this.newstypeItemValue = ''
    if (itemValue != '-1') {
      this.newstypeItemValue = itemValue
    }
    this.newTypeIndex = index
    // this.newstypeItemValue = itemValue
    this.page.pageSize = 10
    this.page.pageNum = 0
    this.newsListPage()
  },
  fnCopy (id,index) {
    this.detailUrl = prewebUrl + '/' + 'societyArticleNewsDetail?id=' + id
    var text = prewebUrl + '/' + 'societyArticleNewsDetail?id=' + id
    // console.log(this.detailUrl)
    // setTimeout(() => {
      let clipboard = new Clipboard("#cop"+index,{
        text: function() {
            return text;
        }
      });
      clipboard.on("success", (e) => {
        Toast("复制成功");
        console.log(e)
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        clipboard.destroy();
      });
    // }, 100)
  },
  goDetail(id){
    this.$store.commit('home/setCommonTopName', window.localStorage.getItem('societyName'));
    this.$router.push({path: '/societyArticleNewsDetail', query: {id:id,societyId:this.societyId,societyName:this.societyName}});
  }
 }
}



// WEBPACK FOOTER //
// ./src/pages/societyArticleNews/societyArticleNews.vue